import moment from 'moment'

export const increaseHoursInDate = (timestamp, hoursToIncrease) => {
	const date = moment(timestamp)

	date.add(hoursToIncrease, 'hours')

	return date.toISOString()
}
